import { makeStyles } from '@material-ui/core';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { PaymentService } from './services/PaymentService';
import React from 'react';
import { useParams } from 'react-router-dom';
import { ITransactionReq } from '../../../utils/PaymentInterfaces';
import { transactionReqDefaultValue } from '../../../utils/defaultNullValues';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
    success: {
        display: "flex",
        justifyContent: "center",
        marginTop: 50
    },
    icon: {
        color: "green",
        fontSize: "50px !important"
    },


    span: {
        fontSize: 50
    },
    text: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    loading: {
        width: "100%",
        position: "absolute",
        top: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        left: 0
    },
    spanNext: {
        fontSize: 14,
        marginBottom: 20
    },
    go: {
        fontSize: 14,
        fontFamily: "Josefin Sans",
        color: "#FFFFFF",
        textTransform: "capitalize",
        textAlign: "center",
        padding: "8px 14px",
        borderRadius: 100,
        background: "#890608",
        marginTop: 20,
        "&:hover": {
            background: "#B5551B",
        },
    },
    linkContainerButton:{
        textDecoration: 'none'
    },
    flex: {
        display: "flex",
        flexDirection: "column",
        marginTop: 20
    }
}))
const paymentService= new PaymentService();
export const PaymentSuccessOrange = () => {
    const classes = useStyles();
    const [ , setLoadingPage]=React.useState<boolean>(true);
    const [ , setTransaction]=React.useState<ITransactionReq>(transactionReqDefaultValue);
    const params: { id: string } = useParams();
    const { t } = useTranslation();

  React.useEffect(() => {
    paymentService
      .getTransactionById(params.id)
      .then((response) => {
        if (response.success) {
            setTransaction(response.data)
        }

        setLoadingPage(false);
      })
      .catch((error) => {
        setLoadingPage(false);
        console.log('PaymentSuccess comp error', error)
      });
  }, [params.id]);

    return (
        <div className={classes.success}>
            <div className={classes.text}>
                <CheckCircleIcon className={classes.icon}/>
                <span className={classes.span}>
                    {t('label.paiement-accepte')}
                </span>

            </div>
        </div>
    )
}
